// extracted by mini-css-extract-plugin
export var active = "_97-a";
export var activeIndicator = "_97-9";
export var disabled = "_97-b";
export var fullWidth = "_97-2";
export var lg = "_97-7";
export var md = "_97-6";
export var redoButtonTabGroup = "_97-0";
export var sm = "_97-5";
export var tabButton = "_97-4";
export var tabButtonsContainer = "_97-1";
export var themeDestructive = "_97-d";
export var themeNormal = "_97-c";
export var themeSuccess = "_97-e";
export var xl = "_97-8";
export var xs = "_97-3";